import React from 'react';
import PropTypes from 'prop-types';
import { Card, Typography } from 'antd';
import styled from 'styled-components';
const { Text } = Typography;

const ControlWithLabel = ({ label, className, children }) => (
  <StyledCard bordered={false} className={className}>
    <Text>{label}</Text>
    {children}
  </StyledCard>
);

const StyledCard = styled(Card)`
  & > .ant-card-body {
    display: flex;
    flex-direction: column;
    padding: 0;

    & > .ant-typography {
      font-size: 12px;
      font-weight: 400;
      color: #748aa1;
    }
  }
`;

ControlWithLabel.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

export default ControlWithLabel;
